"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public';

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _state = _interopRequireDefault(require("@/libs/state"));

var Misc = _interopRequireWildcard(require("@/helpers/Misc"));

var _default = {
  data: function data() {
    return {
      title: 'Where are you connecting today?',
      buttonText: '',
      server_type: 'default',
      server: '',
      tls: false,
      nick: '',
      password: '',
      encoding: 'utf8',
      channel: '',
      znc_network: '',
      znc_network_support: true,
      direct: false,
      direct_path: '',
      show_type_switcher: true,
      show_password_box: false,
      is_connecting: false,
      network: null
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var saveThisSessionsState, network, fragment, uriCheck, connections, con;
      return _regenerator.default.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              saveThisSessionsState = false; // If we have networks from a previous state, launch directly into it

              if (_state.default.networks.length > 0) {
                network = _state.default.networks[0];

                _state.default.setActiveBuffer(network.id, network.serverBuffer().name);

                saveThisSessionsState = true;
                this.$emit('start');
              } else if (window.location.hash.substr(1)) {
                fragment = window.location.hash.substr(1); // Check to see if we're dealing with an encoded irc: uri (browsers do this
                // when clicking an IRC link)

                uriCheck = fragment.substr(0, 7).toLowerCase();

                if (uriCheck === 'ircs%3a' || uriCheck.substr(0, 6) === 'irc%3a') {
                  fragment = decodeURIComponent(fragment);
                }

                connections = Misc.parseIrcUri(fragment); // If more than 1 connection string is given, skip the connection screen
                // and add them all right away.

                if (connections.length === 0) {
                  saveThisSessionsState = true;
                  this.applyDefaults();
                } else if (connections.length === 1) {
                  saveThisSessionsState = false;
                  this.server_type = 'default_simple';
                  this.show_type_switcher = false;
                  con = connections[0];
                  this.server = con.server + ':' + con.port;
                  this.tls = con.tls;
                  this.nick = this.processNickRandomNumber(con.nick);
                  this.channel = con.channels.join(',');
                  this.direct = con.direct;
                  this.encoding = con.encoding;

                  if (con.params.type === 'znc') {
                    // Older ZNC versions only support user:pass while newer supports
                    // user/network:pass. Setting the network to _ denotes that we are
                    // connecting to an older ZNC without network support.
                    if (con.params.network === '_') {
                      this.znc_network_support = false;
                    } else {
                      this.znc_network = con.params.network || '';
                    }

                    this.server_type = 'znc';
                    this.title = 'Enter your password to connect to ZNC';
                  } else {
                    this.title = 'Enter a nickname to join';
                  }
                } else if (connections.length > 1) {
                  saveThisSessionsState = false;
                  (0, _forEach.default)(connections).call(connections, function (con, idx) {
                    var _context;

                    var net = _state.default.addNetwork(con.server, con.nick, {
                      server: con.server,
                      port: con.port,
                      tls: con.tls,
                      password: con.password || ''
                    });

                    (0, _forEach.default)(_context = con.channels).call(_context, function (channelName) {
                      var buffer = _state.default.addBuffer(net.id, channelName);

                      buffer.enabled = true;
                    }); // Set the first server buffer active

                    if (idx === 0) {
                      _state.default.setActiveBuffer(net.id, net.serverBuffer().name);
                    }
                  });
                  this.$emit('start');
                }
              } else {
                saveThisSessionsState = true;
                this.applyDefaults();
              }

              if (_state.default.settings.startupOptions.greetingText) {
                this.title = _state.default.settings.startupOptions.greetingText;
              }

              if (_state.default.settings.startupOptions.buttonText) {
                this.buttonText = _state.default.settings.startupOptions.buttonText;
              } else {
                this.buttonText = this.$t('connect');
              }

              if (saveThisSessionsState) {
                _state.default.persistence.watchStateForChanges();
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    readableStateError: function readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    startUp: function startUp() {
      var _this = this;

      var net;

      if (!this.nick) {
        this.$el.querySelector('.kiwi-customserver-nick input').focus();
        return;
      }

      var nick = this.nick;

      if (this.server_type === 'znc') {
        // Older ZNC versions only support user:pass while newer supports user/network:pass
        var password = nick;

        if (this.znc_network) {
          password += '/' + this.znc_network;
        }

        password += ':' + this.password;
        net = _state.default.addNetwork('ZNC', 'ZNC', {
          server: this.server.split(':')[0],
          port: (0, _parseInt2.default)(this.server.split(':')[1] || 6667, 10),
          tls: this.tls,
          password: password
        });
      } else {
        net = _state.default.addNetwork('Network', nick, {
          server: this.server.split(':')[0],
          port: (0, _parseInt2.default)(this.server.split(':')[1] || 6667, 10),
          tls: this.tls,
          password: this.password,
          direct: this.direct,
          path: this.direct_path,
          encoding: this.encoding
        });
      }

      if (net) {
        var hasSetActiveBuffer = false;
        var bufferObjs = Misc.extractBuffers(this.channel);
        (0, _forEach.default)(bufferObjs).call(bufferObjs, function (bufferObj, idx) {
          var buffer = _state.default.addBuffer(net.id, bufferObj.name);

          buffer.enabled = true;

          if (bufferObj.key) {
            buffer.key = bufferObj.key;
          }

          if (idx === 0) {
            _state.default.setActiveBuffer(net.id, buffer.name);

            hasSetActiveBuffer = true;
          }
        });

        if (!hasSetActiveBuffer) {
          _state.default.setActiveBuffer(net.id, net.serverBuffer().name);
        }

        this.is_connecting = true;
        this.network = net;
        net.ircClient.connect();

        var onRegistered = function onRegistered() {
          (0, _setTimeout2.default)(function () {
            _this.is_connecting = false;
          }, 1000);

          _this.$emit('start');

          net.ircClient.off('registered', onRegistered);
          net.ircClient.off('close', onClosed);
        };

        var onClosed = function onClosed() {
          (0, _setTimeout2.default)(function () {
            _this.is_connecting = false;
          }, 1000);
          net.ircClient.off('registered', onRegistered);
          net.ircClient.off('close', onClosed);
        };

        net.ircClient.once('registered', onRegistered);
        net.ircClient.once('close', onClosed);
      }
    },
    processNickRandomNumber: function processNickRandomNumber(nick) {
      // Replace ? with a random number
      var tmp = (nick || '').replace(/\?/g, function () {
        return Math.floor(Math.random() * 100).toString();
      });
      return (0, _trim.default)(_lodash.default).call(_lodash.default, tmp);
    },
    infoClick: function infoClick() {
      if (this.network) {
        var net = this.network;

        _state.default.setActiveBuffer(net.id, net.serverBuffer().name);
      }

      this.$emit('start');
    },
    applyDefaults: function applyDefaults() {
      this.server = _state.default.settings.startupOptions.server;
      this.tls = _state.default.settings.startupOptions.tls;
      this.nick = this.processNickRandomNumber(_state.default.settings.startupOptions.nick);
      this.channel = _state.default.settings.startupOptions.channel;
      this.direct = _state.default.settings.startupOptions.direct;
      this.direct_path = _state.default.settings.startupOptions.direct_path;
      this.encoding = _state.default.settings.startupOptions.encoding; // Only include the port in the server box if it's not the default

      if (_state.default.settings.startupOptions.port.toString() !== '6667') {
        this.server += ':' + _state.default.settings.startupOptions.port.toString();
      }

      this.title = 'Where are you connecting today?';
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["CustomServer"]
window._kiwi_exports.components.startups.CustomServer = exports.default ? exports.default : exports;
